<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Listy rezerwowe</span>
        <h3 class="page-title">Kolejne wizyty</h3>
      </d-col>
    </d-row>
    <visits-popup
      v-if="showModalVisit"
      :button-edit="false"
      :key="componentKeyPopup"
      :close-modal="handleCloseInfo"
      :show-modal="showModalVisit"
      :visit="visit[0]"
      :get-day="dayNames[0].name"
      :my-account="''"/>
    <d-row
      v-if="loaded"
      style="width: 100%;"
      class="d-flex ml-0 mb-3 page-filters">
      <validation-observer
        ref="reservations-filters-form"
        tag="form"
        style="width: 100%;"
        class="d-flex">
        <d-input
          placeholder="Podaj imię i nazwisko dziecka / wnioskodawcy"
          v-model="filters.search" />
        <v-select
          style="width: 100%;"
          class="ml-2"
          :options="services"
          :reduce="service => service.id"
          v-model="filters.service_id"
          placeholder="Lista usług"
          :searchable="false"
          label="name">
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.name ? option.name : '' }}
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.name ? option.name : '' }}
            </div>
          </template>
        </v-select>
        <v-select
          style="width: 50%;"
          class="ml-2"
          :options="institutions"
          :reduce="institution => institution.id"
          v-model="filters.institution_id"
          placeholder="Lista placówek"
          :searchable="false"
          label="name">
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.name ? option.name : '' }}
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.name ? option.name : '' }}
            </div>
          </template>
        </v-select>
        <v-select
          style="width: 50%;"
          class="ml-2"
          :options="accountStatusUser"
          v-model="filters.status"
          placeholder="Status"
          :searchable="false"
          label="text">
        </v-select>
        <v-select
          style="width: 50%;"
          class="ml-2"
          :options="reservationPriorities"
          v-model="filters.priority"
          :reduce="priorities => priorities.id"
          placeholder="Ważna wizyta"
          :searchable="false"
          label="name">
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.name ? option.name : '' }}
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.name ? option.name : '' }}
            </div>
          </template>
        </v-select>
        <d-button
          theme="info"
          outline
          class="text-nowrap ml-2"
          @click.prevent="validateFiltersForm">Szukaj</d-button>

        <d-button
          theme="danger"
          outline
          class="text-nowrap ml-2"
          @click.prevent="clearFilters">Resetuj filtry</d-button>
      </validation-observer>
    </d-row>
    <d-card style="width: 100%;">
      <table class="table mt-0 mb-0 full-width reservation-table">
        <thead class="bg-light">
        <tr>
          <th scope="col" class="border-0">Pacjent</th>
          <th scope="col" class="border-0">Dane kontaktowe</th>
          <th scope="col" class="border-0">Placówka</th>
          <th scope="col" class="border-0">Informacje</th>
          <th scope="col" class="border-0" style="min-width: 9rem;">Wizyty odwołane</th>
          <th scope="col" class="border-0">Status</th>
          <th scope="col" class="border-0">Akcje</th>
        </tr>
        </thead>
        <tbody v-if="loaded">
        <tr
          v-for="(reservation, index) of reservationsArr"
          :key="'reservation-' + index">
          <td :class="['align-middle', reservation.priority === 1 ? 'custom-priority-red' : '', reservation.user_id !== 0 ? 'custom-priority-blue' : '']">
            {{ reservation.patient_name }} {{ reservation.patient_last_name }}
            <span class="reservation-pesel">Numer na liście: <span class="reservation-school-value">{{ reservation.order_number }}</span></span>
            <span class="reservation-pesel">PESEL: <span class="reservation-pesel-value">{{ reservation.patient_pesel }}</span></span>
            <span class="reservation-pesel">Szkoła: <span class="reservation-school-value">{{ reservation.school_name ? reservation.school_name : '' }}</span></span>
          </td>
          <td
            :class="['align-middle', reservation.priority === 1 ? 'custom-priority-red' : '']">
            {{ reservation.guardian_name + ' ' + reservation.guardian_last_name }}
            <span class="reservation-pesel">
              Tel:
              <span class="reservation-school-value">
                {{ reservation.guardian_phone }}
              </span>
            </span>
            <span class="reservation-pesel">
              Email:
              <span class="reservation-school-value">
                {{ reservation.guardian_email }}
              </span>
            </span>
          </td>
          <td :class="['align-middle', reservation.priority === 1 ? 'custom-priority-red' : '']">
            {{ reservation.institution_name }}
          </td>
          <td :class="['align-middle', reservation.priority === 1 ? 'custom-priority-red' : '']">
            <span class="reservation-reason">Data zgłoszenia: <span class="reservation-reason-value-green">{{ reservation.created_at.slice(0, 16) }}</span></span>
            <span class="reservation-reason">Wnioskuje o: <span class="reservation-reason-value">{{ reservation.diagnosis_name ? reservation.diagnosis_name : '' }}</span></span>
          </td>
          <td :class="[(reservation.count_cancelled_visits !== 0 ? (((reservation.count_cancelled_visits / reservation.count_visits) * 100) <= 10 ? 'promising' :
              (((reservation.count_cancelled_visits / reservation.count_visits) * 100) <= 20 ? 'attention' : 'danger')) : 'promising'), (reservation.priority === 1 ? 'custom-priority-red' : '')]">
            {{ reservation.count_cancelled_visits !== 0 ? (((reservation.count_cancelled_visits / reservation.count_visits) * 100).toString().slice(0, 4) + ' %' ) : ( ' 0' + ' % ') }}
          </td>
          <td :class="['align-middle', reservation.priority === 1 ? 'custom-priority-red' : '']">
            <d-badge class="user-status" style="width: 12rem;" :theme="reservation.status === 'RL_TO_ACCEPT' ? 'primary' : 'success'">
              {{ reservation.status === 'RL_TO_ACCEPT' ? 'Do zaakceptowania' : 'Zaakceptowane' }}
            </d-badge>
          </td>
          <td
            :class="['align-middle', reservation.priority === 1 ? 'custom-priority-red' : '']"
            style="width: 240px; white-space: nowrap;">
            <d-dropdown
              v-if="reservation.service_id !== 0"
              :disabled="reservation.status !== 'RL_TO_ACCEPT'"
              class="dropdownStatus mr-2"
              :theme="reservation.status === 'RL_TO_ACCEPT' ? 'secondary' : 'success'"
              :menu-id="`dropdown-${reservation.id}`"
              :text="reservation.status === 'RL_TO_ACCEPT' ? 'Zmień status' : 'Zaakceptowane'">
              <d-dropdown-item>
                <d-button
                  style="width: 100%"
                  theme="success"
                  @click="handleAccepted(reservation.id)"
                  :menu-id="`dropdown-accepted-${reservation.id}`">
                  Zaakceptuj
                </d-button>
              </d-dropdown-item>
            </d-dropdown>
            <d-button
              v-if="reservation.visit !== null"
              outline
              :name="reservation.id"
              class="patient_button mr-2"
              theme="info"
              @click.prevent="showModalInfo(reservation.visit.id)"
              title="Podgląd poprzedniej wizyty">
              <template v-if="!spinner"><i class="material-icons">person_search</i></template>
              <template v-else-if="reservation.id === reservationId">
                <div class="spinner-border spinner-border-sm" role="status"></div>
              </template>
              <template v-else-if="reservation.id !== reservationId">
                <i class="material-icons">person_search</i>
              </template>
            </d-button>
            <d-button
              theme="primary"
              class="mr-2"
              @click.prevent="$router.push('/reservation_list/detale/' + reservation.id)"
              title="Szczegóły wniosku">
              <i class="material-icons">search</i>
            </d-button>
          </td>
        </tr>
        <tr v-if="reservationsArr.length === 0">
          <td
            colspan="6"
            class="text-center">
            Brak rezerwacji do wyświetlenia&hellip;
          </td>
        </tr>
        </tbody>
      </table>
      <div v-if="!loaded" class="pb-3 pt-3 text-center">
        Trwa ładowanie danych&hellip;
      </div>

      <d-alert
        v-if="loadError"
        show
        theme="warning">
        Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
      </d-alert>
    </d-card>
    <div class="reservation-legend">
      <div class="reservation-legend-box">
        Rezerwacja z podwyższonym priorytetem
        <span class="red"></span>
      </div>
      <div class="reservation-legend-box">
        Rezerwacja dodana przez specjalistów
        <span class="blue"></span>
      </div>
    </div>
    <pagination :meta-data="paginationMetaData" />
  </d-container>
</template>

<script>
import debounce from 'lodash.debounce';
import FormUtils from './../../utils/FormUtils.js';
import HasFilters from './../../mixins/HasFilters.vue';
import HasPagination from './../../mixins/HasPagination.vue';
import ListUtils from './../../utils/ListUtils.js';
import Pagination from './../../components/common/Pagination.vue';
import VisitsPopup from '@/views/visits/VisitsPopup';
import CalendarUtils from '@/utils/CalendarUtils';

export default {
  name: 'reservation-list-first',
  mixins: [
    HasFilters,
    HasPagination
  ],
  components: {
    VisitsPopup, 'pagination': Pagination
  },
  computed: {
    reservationPriorities () {
      return [
        {
          id: 0,
          name: 'NIE'
        },
        {
          id: 1,
          name: 'TAK'
        }
      ];
    },
    accountStatusUser () {
      return [
        {
          value: 'RL_TO_ACCEPT',
          text: 'Wnioski do zaakceptowania'
        },
        {
          value: 'RL_ACCEPTED',
          text: 'Wnioski zaakceptowane'
        }
      ];
    },
    startDate () {
      return [this.currentDate.year, this.currentDate.month, this.currentDate.date].map(n => n < 10 ? '0' + n : n).join('-');
    },
    dayNames () {
      return CalendarUtils.getDayNames(this.startDate, this.daysCount);
    },
  },
  data() {
    return {
      institutions: [],
      reservations: [],
      reservationsArr: [],
      services: [],
      patients: [],
      visit: [],
      patientId: '',
      reservationId: 0,
      removeInProgress: false,
      showPatientInfo: false,
      loadValueForPopup: false,
      spinner: false,
      loaded: false,
      loadError: false,
      showModalVisit: false,
      reservationKey: 0,
      componentKeyPopup: 0,
      daysCount: 1,
      currentDate: {
        date: 0,
        month: 0,
        year: 0,
        yearAdd: 0
      },
      filters: {
        search: '',
        status: '',
        priority: '',
        institution_id: '',
        service_id: ''
      }
    };
  },
  watch: {
    reservations () {
      this.getNewReservationNew();
    },
    services(newVal) {
      if (newVal && newVal.length && newVal[0].id !== 0) {
        this.services.unshift({ id: 0, name: 'Brak usługi' });
      }
    }
  },
  mounted () {
    this.loadFilteredData();
    this.loadInstitutionsListData();
    // this.loadPatientsListData();
    this.loadServicesListData();
  },
  methods: {
    showModalInfo (visitId) {
      this.loadFilteredDataVisit(visitId);
    },
    handleCloseInfo() {
      this.showModalVisit = false
      this.componentKeyPopup += 1
    },
    getNewReservationNew () {
      const reservations = this.reservations;
      let arr = [];
      for (let i = 0; i < reservations.length; i++) {
        if (reservations[i].type === 'RL_ANOTHER_VISIT') {
          arr[i] = reservations[i]
        }
      }
      this.reservationsArr = arr.filter(n => n);
    },
    loadFilteredDataVisit (id) {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/visits/list',
        outputKey: 'visit',
        params: {
          pagination: false,
          visit_id: id
        },
        successAction: () => {
          setTimeout(() => {
            this.showModalVisit = true
          }, 400)
        }
      });
    },
    loadInstitutionsListData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: 'institutions/items',
        outputKey: 'institutions',
        params: {
          pagination: false
        },
      });
    },
    loadServicesListData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: 'services/items',
        outputKey: 'services',
        params: {
          pagination: false
        },
      });
    },
    loadPatientsListData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/patients/items',
        outputKey: 'patients',
        params: {
          pagination: false
        },
      });
    },
    debouncedLoadFilteredData: debounce(function () {
      this.$bus.$emit('view-filters-save');
      this.loadFilteredData();
    }, 250),
    loadFilteredData () {
      let where = {
        search: this.filters.search,
        type: 'RL_ANOTHER_VISIT'
      };
      if (this.filters.status !== null && this.filters.status && this.filters.status.value) {
        where.status = this.filters.status.value;
      }
      if (this.filters.institution_id !== null && this.filters.institution_id) {
        where.institution_id = this.filters.institution_id;
      }
      if (this.filters.priority !== null && this.filters.priority) {
        where.priority = this.filters.priority;
      }
      if (this.filters.service_id !== null && this.filters.service_id) {
        where.service_id = this.filters.service_id;
      }
      ListUtils.loadItemsData(this, {
        endpoint: '/patients/reservation-list/items?page=' + this.currentPage,
        listField: 'reservations',
        pagination: true,
        params: {
          where
        }
      });
    },
    clearFilters () {
      this.loaded = false;
      this.loadError = false;
      this.filters = {
        search: '',
        status: '',
        institution_id: '',
        service_id: ''
      };
      this.$bus.$emit('view-filters-reset');
    },
    reservationStatsGet () {
      this.$store.dispatch('patientsReservationStatsGet')
    },
    validateFiltersForm () {
      this.$bus.$emit('pagination-reset');
      FormUtils.validate(this.$refs['reservations-filters-form'], this.debouncedLoadFilteredData);
    },
    handleAccepted (reservationID) {
      this.removeInProgress = true;

      ListUtils.AcceptReservationList(this, {
        endpointBase: '/patients/reservation-list/accept/',
        id: reservationID,
        successAction: () => {
          this.removeInProgress = false;
          this.loadFilteredData();
          this.reservationStatsGet();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    }
  }
}
</script>

<style lang="scss">
  @import "../../assets/scss/reservation-list.scss";
</style>
